import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint, PdfImage } from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { OptsImage } from '../optsImage';
import { IItemCount } from '@educraft/base';
import { GUtil } from '../../pdf/gutil';
import { calcGridRects } from '../../pdf/board/grid';
import '../../pdf/draw/primitives';
import '../../pdf/draw/image';
import '../../pdf/draw/cut';

/**
 * Karty_Dopln (Cards Fill) - Color/B&W card pairs
 *
 * Layout: 2 landscape pages, variable grid based on item count.
 * Page 1: color images. Page 2: black & white versions.
 *
 * Grid configurations (from grid.ts):
 * 3→3×1, 4→2×2, 5-6→3×2, 8→4×2, 9→3×3, 10→5×2, 12→4×3, 15→5×3,
 * 16→4×4, 18→6×3, 20→5×4, 24→6×4
 *
 * Migrated from C# EduFrame.Img10.Generators.Karty_Dopln
 */
export class KartyDopln implements ILayoutImageGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 3;
  }
  countMax(): number {
    return 24;
  }

  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);

    const count = Math.min(opts.list.length, this.countMax());
    const { rects } = calcGridRects(count, margin, PdfSize.A4H);

    const page1 = pdf.addPage(true);
    const page2 = pdf.addPage(true);

    for (let i = 0; i < rects.length; i++) {
      const rect = rects[i];

      page1.drawRectangle(GUtil.cutPen, null, rect);
      page2.drawRectangle(GUtil.cutPen, null, rect);

      const imgRect = new PdfRect(
        rect.x + margin,
        rect.y + margin,
        rect.width - 2 * margin,
        rect.height - 2 * margin
      );

      page1.drawImageCenter(opts.list[i].image, imgRect);

      const bwImage = await opts.list[i].image.toBlackWhite(pdf);
      page2.drawImageCenter(bwImage, imgRect);
    }
  }
}
